import React from "react";
import { useIntl } from "react-intl";
import "../../../components/circle-box/CircleBoxWithText.js";
import { CircleBoxWithColorMapping } from "../../../components/circle-box/CircleBoxWithColorMapping.js";
import "../../../components/circle-box/CircleBox.js";
import { Brand } from "../../../contract/pam.js";
import { SystemColorsEnum } from "../../../style/types.js";
import "@mui/material";
import "../../../style/hooks.js";
import { localizedBrand } from "../constants.js";
function BrandCircle({ value }) {
  const { formatMessage } = useIntl();
  const colorMapping = {
    WPTG: SystemColorsEnum.LightBlue,
    WPTGO: SystemColorsEnum.Burgundy,
    WPTGPUKE: SystemColorsEnum.Bronze,
    UNKNOWN: SystemColorsEnum.DarkGrey,
    NEXAPOKER: SystemColorsEnum.Green,
    AKSPOKER: SystemColorsEnum.WarmYellow
  };
  const res = value !== Brand.Unknown ? value : void 0;
  const label = res ? localizedBrand[res] : void 0;
  return /* @__PURE__ */ React.createElement(CircleBoxWithColorMapping, { value: res, label: label && formatMessage(label), colorMapping });
}
export {
  BrandCircle
};
//# sourceMappingURL=BrandCircle.js.map
